import CloseIcon from '@mui/icons-material/Close';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(
  ({ theme }) => ({
    height: '4rem',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: '0 0.5rem'
    }
  })
);

export const BackButtonContainer = styled(Box)(
  ({ theme }) => ({
    width: 'auto',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      width: '2rem'
    }
  })
);

export const BackIcon = styled(NavigateBeforeIcon)({
  fontSize: '2rem'
});

export const TitleContainer = styled(Box)({
  minWidth: 'fit-content'
});

export const ExitButtonContainer = styled(Box)(
  ({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('sm')]: {
      width: '2rem',
      justifyContent: 'center'
    }
  })
);

export const ExitIcon = styled(CloseIcon)({
  fontSize: '2rem'
});
